module.exports = __webpack_public_path__ + "img/slide-18.aebb8194.jpg";